import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const Whatsappbutton = () => {
  return (
    <a
      href="https://wa.me/9415481386"   // 
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
      style={{
        position: "fixed",
        right: "20px",
        bottom: "20px",
        width: "55px",
        height: "55px",
        zIndex: 9999,
      }}
    >
      <FaWhatsapp size={28} color="white" />
    </a>
  );
};

export default Whatsappbutton;
